import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useSite } from "@/lib/site";

export function AboutSection({ content }) {
  const { lang } = useSite();
  const c = content?.about;
  const caption = lang === "fr" ? "L'application de réservation de salons de coiffure" : "تطبيق حجز مواعيد الحلاقين";
  return (
    <section id="about" className="bg-cream py-24 sm:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="relative mx-auto max-w-md">
            <div className="absolute -inset-4 overflow-hidden rounded-[2.8rem]" aria-hidden="true">
              <div className="logo-aura absolute inset-0" />
            </div>
            <div className="absolute -inset-4 rounded-[2.5rem] bg-gold/10 blur-2xl" aria-hidden="true" />
            <div className="shine-sweep relative rounded-[2.5rem] border border-line bg-white p-10 shadow-[0_30px_60px_-30px_rgba(15,56,44,0.25)] transition-transform duration-500 hover:-rotate-1">
              <img
                src="/logo.jpg"
                alt="شعار تطبيق حلاق - 7ala9"
                className="w-full rounded-2xl"
                data-testid="about-logo-image"
              />
              <p className="mt-6 text-center font-head text-lg font-bold text-forest-900">
                حلاق - 7ala9
              </p>
              <p className="mt-1 text-center text-xs text-moss">{caption}</p>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHeading eyebrow={c?.eyebrow} title={c?.title} />
          <Reveal delay={0.1}>
            <div className="mt-6 space-y-5">
              {(c?.paragraphs || []).map((p, i) => (
                <p key={i} className="leading-loose text-moss">
                  {p}
                </p>
              ))}
            </div>
            <ul className="mt-8 space-y-4">
              {(c?.points || []).map((point, i) => (
                <li key={i} className="flex items-center gap-3" data-testid={`about-point-${i}`}>
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-gold-dark" />
                  <span className="font-medium text-ink">{point}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
